import { LoginWrapper } from "./LoginWrapper";
import LoginButton from "./LoginButton";
import { Navigate } from "react-router-dom";
import { getIsAuthed } from "./RequireAuth";

const Login = () => {
  const isAuthenticated = getIsAuthed();

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }
  return (
    <LoginWrapper>
      <LoginButton />
    </LoginWrapper>
  );
};

export default Login;
